import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { Input } from './Input'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'

export default function TimeList() {
  let w_timelist = localStorage.getItem('w-timelist')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (w_timelist) {
      setOpen(true)
    } else {
      navigate('/')
    }
  }, [])
  return <>{open && <DefinissezObjective setOpen={setOpen} />}</>
}

function DefinissezObjective({ setOpen }) {
  const { t: tLayout } = useTranslation('layout')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let w_timelist = localStorage.getItem('w-timelist')
  const [userTimeList, setUserTimeList] = useState([])
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const { handleSubmit, control, reset, setValue } = useForm({})

  // LAP-752 — backend serves the 12 list items as FR canonical strings (see
  // `timeList` in AppSite/views.py). Lookup the localised label and fall back
  // to the raw value if not registered.
  const translateItem = (raw) =>
    raw && tLayout(`wizardTimeList.items.${raw}`, { defaultValue: raw })

  useEffect(() => {
    fetchUserTimeList()
  }, [])

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    // const values = []
    // selectedCheckboxes.forEach((e) => {
    //   values.push(fintrest.filter((f) => f.id === e)[0].Nom)
    // })
    const payload = {
      selected: selectedCheckboxes,
    }
    const response = await makePostRequest('/api/app/user-timelist/', payload, {}, true)
    if (response.status === 200) {
      if (w_timelist) {
        await makePostRequest(
          '/api/app/user-wizard/',
          { step: w_timelist, completed: true, skip: true },
          {},
          true,
        )

        dispatch(setUserWizardDone({ step: w_timelist, completed: true, skip: true }))
        localStorage.removeItem('w-timelist')
        navigate('/')
      }

      handleClose()
    }
  }
  const handelOnChange = (e) => {
    const checkboxValue = parseInt(e.target.name.replace('fi-', ''))
    let updatedSelectedCheckboxes

    if (selectedCheckboxes.includes(checkboxValue)) {
      updatedSelectedCheckboxes = selectedCheckboxes.filter(
        (checkbox) => checkbox !== checkboxValue,
      )
    } else {
      updatedSelectedCheckboxes = [...selectedCheckboxes, checkboxValue]
    }

    setSelectedCheckboxes(updatedSelectedCheckboxes)
  }
  const fetchUserTimeList = async () => {
    const { data, status } = await makeGetRequest('/api/app/user-timelist/', {}, true)
    if (status === 200) {
      setUserTimeList(data)
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={true} className="no-drag">
        <DialogTitle sx={{ color: '#383838 !important' }}>{tLayout('wizardTimeList.title')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Box textAlign={'center'} fontWeight={700}>
              {tLayout('wizardTimeList.heading')}
            </Box>
            <Box mt={3} mb={5}>
              {tLayout('wizardTimeList.description')}
            </Box>

            <FormGroup>
              <Grid container spacing={1}>
                {userTimeList.map((ele) => (
                  <Grid item xs={4} key={ele.id}>
                    <FormControlLabel
                      className="ficheck"
                      control={<Checkbox />}
                      onChange={handelOnChange}
                      label={translateItem(ele.name)}
                      name={'fi-' + ele.id}
                    />
                  </Grid>
                ))}
              </Grid>
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button type="submit">{tLayout('wizardTimeList.submitButton')}</Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_timelist) {
                  localStorage.removeItem('w-timelist')
                  navigate('/')
                }
              }}
            >
              {tLayout('wizardTimeList.cancelButton')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
